import React from 'react'
import { Container } from 'reactstrap'

import CollapsibleCard from '../../../CollapsibleCard'

import secure from '../../mobile-workforce/why-workspaces/assets/secure.svg'
import flexible from '../../mobile-workforce/why-workspaces/assets/flexible.svg'
import cost from '../../mobile-workforce/why-workspaces/assets/cost.svg'
import globe from '../../mobile-workforce/why-workspaces/assets/globe.svg'

const ITEMS = [
  {
    title: 'Improves Security',
    icon: secure,
    stripeColor: 'blue',
    text:
      'Amazon CloudFront is protected by the AWS Global Network Security Procedures which include DDoS protections, GEO restrictions, and a wide range of compliances like HIPAA, PCI, and FedRamp.',
  },
  {
    title: 'Improves Performance',
    icon: flexible,
    stripeColor: 'green',
    text:
      'CloudFront automatically maps network conditions and intelligently routes your user’s traffic to the most performant AWS edge location to serve up cached or dynamic content.',
  },
  {
    title: 'Reduces Cost',
    icon: cost,
    stripeColor: 'dark-blue',
    text:
      'When integrating CloudFront with other AWS services, there are no transfer fees for origin fetches from any AWS origin and AWS Certificate Manager (ACM) offers custom TLS certificates, at no charge.',
  },
  {
    title: 'Service Integration',
    icon: globe,
    stripeColor: 'orange',
    text:
      'Amazon CloudFront is integrated with AWS services such as Amazon S3, Amazon EC2, Elastic Load Balancing, Amazon Route 53, Web Application Firewall, and AWS Elemental Media Services for easy set-up.',
  },
]

const WhyCloudFront = () => {
  return (
    <section className="WhyWorkspaces">
      <Container>
        <h2 className="WhyWorkspaces__title">
          Benefits&nbsp;
          <span className="text-dark-blue">of Implementing Amazon CloudFront</span>
        </h2>

        <div className="WhyWorkspaces__lead"></div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {ITEMS.map((item, idx) => (
            <div
              className="w-100 w-md-50 w-lg-33 w-xl-25 mb-3 pl-md-2 pr-md-2 pr-lg-3 mb-lg-5"
              key={idx}
            >
              <CollapsibleCard
                {...item}
                isOpenDefault={idx === 0}
                className="CollapsibleCard--bg-offwhite"
              >
                {item.text}
              </CollapsibleCard>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default WhyCloudFront
